import { render, staticRenderFns } from "./ClassesDetails.vue?vue&type=template&id=daa55db8&scoped=true&"
import script from "./ClassesDetails.vue?vue&type=script&lang=js&"
export * from "./ClassesDetails.vue?vue&type=script&lang=js&"
import style0 from "./ClassesDetails.vue?vue&type=style&index=0&id=daa55db8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daa55db8",
  null
  
)

export default component.exports